import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { wrapStructure } from 'util/structure-module';

const moduleFn = () => import('structure/developer-tools').then((m) => ({ structureModule: wrapStructure(m.DeveloperToolsStructure) }));

export default function DeveloperToolsLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/developer-tools/one'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'developer-tools',
        instanceKey: 'one',
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
